<div class="loggedIn" *ngIf="checkIfUserIsLoggedIn() else notLoggedIn">
    <app-my-sidenav></app-my-sidenav>
</div>
<ng-template #notLoggedIn><router-outlet></router-outlet></ng-template>